(function () {
  // Checkbox subskrypcji przy pozycji w szufladzie koszyka.
  //
  // Pokazujemy go tylko przy produktach, ktore maja podpiete plany subskrypcyjne.
  // Stan checkboxa odzwierciedla to, co jest w koszyku: odznaczony przy zakupie
  // jednorazowym (wtedy jest zachetą), zaznaczony przy pozycji juz subskrypcyjnej -
  // dzieki temu klient moze zmienic termin albo wycofac sie bez wracania na karte.
  //
  // Przelaczenie robi /cart/change.js z polem selling_plan. Sprawdzone na zywym
  // koszyku: dziala na ISTNIEJACEJ pozycji, wiec nie musimy jej usuwac i dodawac
  // na nowo - pozycja nie zmienia miejsca i nic nie mruga klientowi przed oczami.

  function API() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function zl(gr) { return (gr / 100).toFixed(2).replace('.', ',') + ' zł'; }

  var pamiec = {};   // handle -> dane produktu albo false (brak planow)

  function pobierz(handle) {
    if (pamiec[handle] !== undefined) return Promise.resolve(pamiec[handle]);
    return fetch(API() + 'products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var ma = p && p.selling_plan_groups && p.selling_plans_count !== 0 && p.selling_plan_groups.length;
        pamiec[handle] = ma ? p : false;
        return pamiec[handle];
      })
      .catch(function () { pamiec[handle] = false; return false; });
  }

  function planyDlaWariantu(produkt, variantId) {
    var wariant = null;
    (produkt.variants || []).forEach(function (v) { if (v.id === variantId) wariant = v; });
    if (!wariant) return [];
    var nazwy = {};
    (produkt.selling_plan_groups || []).forEach(function (g) {
      (g.selling_plans || []).forEach(function (sp) { nazwy[sp.id] = sp.name; });
    });
    return (wariant.selling_plan_allocations || []).map(function (a) {
      return {
        id: a.selling_plan_id,
        nazwa: nazwy[a.selling_plan_id] || 'Subskrypcja',
        cena: a.price,
        cenaZwykla: wariant.price,
        rabat: wariant.price ? Math.round((1 - a.price / wariant.price) * 100) : 0
      };
    });
  }

  function styl() {
    if (document.getElementById('rsk-style')) return;
    var s = document.createElement('style');
    s.id = 'rsk-style';
    s.textContent =
      '.rsk{margin:8px 0 2px;font-family:Barlow,var(--font-body-family,sans-serif)}' +
      '.rsk__row{display:flex;align-items:flex-start;gap:8px}' +
      '.rsk__box{flex-shrink:0;width:17px;height:17px;margin:1px 0 0;accent-color:#2e9e5b;cursor:pointer}' +
      '.rsk__lab{font-size:12.5px;line-height:1.4;color:#3a3a34;cursor:pointer}' +
      '.rsk__lab strong{font-weight:700;color:#000}' +
      '.rsk__sel{display:block;width:100%;height:36px;margin:8px 0 0;border:1px solid #d8d3c7;border-radius:7px;padding:0 30px 0 10px;font-family:inherit;font-size:12.5px;font-weight:600;color:#000;background-color:#fff;cursor:pointer;-webkit-appearance:none;-moz-appearance:none;appearance:none}' +
      '.rsk__sel:focus{outline:none;border-color:#000}' +
      '.rsk--on{background:#f2faf4;border:1px solid #bfe3cb;border-radius:9px;padding:9px 10px}' +
      '.rsk--busy{opacity:.55;pointer-events:none}';
    document.head.appendChild(s);
  }

  function pozycjeDOM() {
    var d = document.getElementById('CartDrawer');
    if (!d) return [];
    return [].slice.call(d.querySelectorAll('.hdt-mini-cart__item'));
  }

  // Wariant odczytujemy z linku pozycji (?variant=...), a nie z kolejnosci -
  // kolejnosc bywa inna po odswiezeniu sekcji.
  function wariantZPozycji(el) {
    var a = el.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var href = a.getAttribute('href') || '';
    var m = href.match(/[?&]variant=(\d+)/);
    var handle = (href.match(/\/products\/([^?#]+)/) || [])[1];
    return { variantId: m ? parseInt(m[1], 10) : null, handle: handle || null };
  }

  var zajete = false;

  function ustawPlan(klucz, idPlanu, box) {
    if (zajete) return;
    zajete = true;
    if (box) box.classList.add('rsk--busy');

    fetch(API() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: klucz, quantity: undefined, selling_plan: idPlanu || '' })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (window.RoutinesKoszyk && window.RoutinesKoszyk.odswiez) {
          return window.RoutinesKoszyk.odswiez();
        }
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
      })
      .catch(function () {})
      .then(function () {
        setTimeout(function () { zajete = false; rysuj(); }, 500);
      });
  }

  function rysuj() {
    var elementy = pozycjeDOM();
    if (!elementy.length) return;

    fetch(API() + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (koszyk) {
        elementy.forEach(function (el) {
          var info = wariantZPozycji(el);
          if (!info || !info.handle || !info.variantId) return;

          // linia koszyka odpowiadajaca tej pozycji
          var linia = null;
          (koszyk.items || []).forEach(function (i) {
            if (linia) return;
            if (i.variant_id === info.variantId) linia = i;
          });
          if (!linia) return;

          pobierz(info.handle).then(function (produkt) {
            if (!produkt) { return; }   // brak planow - nic nie pokazujemy

            var plany = planyDlaWariantu(produkt, info.variantId);
            if (!plany.length) return;

            var aktywny = linia.selling_plan_allocation &&
                          linia.selling_plan_allocation.selling_plan
                            ? linia.selling_plan_allocation.selling_plan.id : null;

            var maks = 0;
            plany.forEach(function (p) { if (p.rabat > maks) maks = p.rabat; });

            var box = el.querySelector('.rsk');
            if (!box) {
              box = document.createElement('div');
              box.className = 'rsk';
              box.innerHTML =
                '<div class="rsk__row">' +
                  '<input type="checkbox" class="rsk__box" data-rsk-box>' +
                  '<span class="rsk__lab" data-rsk-lab></span>' +
                '</div>' +
                '<select class="rsk__sel" data-rsk-sel hidden></select>';
              // wstawiamy pod trescia pozycji, nad ewentualnymi dodatkami
              var gniazdo = el.querySelector('.hdt-mini-cart__content') || el;
              gniazdo.appendChild(box);
            }

            var check = box.querySelector('[data-rsk-box]');
            var lab = box.querySelector('[data-rsk-lab]');
            var sel = box.querySelector('[data-rsk-sel]');

            var etykieta = 'Subskrybuj i oszczędź <strong>do ' + maks + '%</strong> na tym zamówieniu';
            if (lab.innerHTML !== etykieta) lab.innerHTML = etykieta;

            var opcje = plany.map(function (p) {
              return '<option value="' + p.id + '"' + (p.id === aktywny ? ' selected' : '') + '>' +
                     p.nazwa + ' — ' + zl(p.cena) + '</option>';
            }).join('');
            if (sel.innerHTML !== opcje) sel.innerHTML = opcje;

            check.checked = !!aktywny;
            sel.hidden = !aktywny;
            box.classList.toggle('rsk--on', !!aktywny);

            check.onchange = function () {
              var domyslny = plany[0];
              plany.forEach(function (p) { if (p.rabat === maks) domyslny = p; });
              ustawPlan(linia.key, check.checked ? domyslny.id : '', box);
            };
            sel.onchange = function () {
              ustawPlan(linia.key, sel.value, box);
            };
          });
        });
      })
      .catch(function () {});
  }

  var timer = null;
  function zaplanuj() { clearTimeout(timer); timer = setTimeout(rysuj, 350); }

  styl();

  // szuflada przebudowuje sie po kazdej zmianie - odtwarzamy checkboxy
  var drawer = document.getElementById('CartDrawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function () { zaplanuj(); })
      .observe(drawer, { childList: true, subtree: true });
    new MutationObserver(function () {
      if (drawer.hasAttribute('open')) zaplanuj();
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  document.addEventListener('cart:updated', zaplanuj);
  setTimeout(rysuj, 1200);

  window.RoutinesSubKoszyk = { rysuj: rysuj };
})();
